import { i18n } from '@/shared/i18n'

export async function uploadImageToS3(blob: Blob, uploadUrl: string): Promise<void> {
  let response: Response
  try {
    response = await fetch(uploadUrl, {
      method: 'PUT',
      headers: { 'Content-Type': blob.type },
      body: blob,
    })
  } catch (error_) {
    const networkError =
      error_ instanceof Error ? error_ : new Error(i18n.t('common.errors.imageUploadFailed'))
    if (
      networkError.message.includes('NetworkError') ||
      networkError.message.includes('Failed to fetch')
    ) {
      throw new Error(i18n.t('common.errors.networkError'))
    }
    throw networkError
  }

  if (!response.ok) {
    if (response.status === 403) {
      throw new Error(i18n.t('common.errors.uploadUrlExpired'))
    }
    throw new Error(i18n.t('common.errors.uploadFailedWithStatus', { status: response.status }))
  }
}
